import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import React, { useState, useEffect } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import ScholarshipsTable from '../Components/ScholarshipsTable';
import DeleteModal from "../../../../Util/DeleteModal";
import { useBoolean } from "@fluentui/react-hooks";
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';

const DefaultPage = () => {
    const [selectedScholarship, setSelectedScholarship] = useState(undefined);
    const [selectedScholarshipTitle, setSelectedScholarshipTitle] = useState("");
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: scholarships, loading }, refetchScholarships] = useAxios("scholarships/all");

    useEffect(() => {
        console.log(scholarships);
    }, [scholarships])

    if (loading) return <Spinner className="absolute-center" label="Loading Scholarships..." />;

    return (
        <>
            <SuccessComponent
                successMessage="Scholarship Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <ScholarshipsTable
                scholarships={scholarships && scholarships.length > 0 ? scholarships.sort((a, b) => a.scholarshipID - b.scholarshipID) : []}
                setSelectedScholarship={setSelectedScholarship}
                setSelectedScholarshipTitle={setSelectedScholarshipTitle}
                selectedScholarship={selectedScholarship}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => window.open(`${url}/${id}/wizard`, '_blank')}
                deleteOnClick={(id, title) => {
                    setSelectedScholarship(id);
                    setSelectedScholarshipTitle(title || "");
                    toggleDeleteModal();
                }}
                refetch={refetchScholarships}
                loading={loading}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetchScholarships()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`scholarships/delete/${selectedScholarship}/`}
                resourceName={selectedScholarshipTitle}
                resourceType="scholarship"
                confirmationValue={selectedScholarshipTitle || undefined}
            />
        </>
    );
};

export default DefaultPage;
